import React from 'react';
import { marked } from 'marked';
import DOMPurify from 'dompurify';

// Styles
import './MarkdownRenderer.scss';

// Create custom renderer
const renderer = new marked.Renderer();

const originalLink = renderer.link.bind(renderer);
renderer.link = (token) => {
  const html = originalLink(token);
  // Add target="_blank" (open new tab) and rel="noopener noreferrer" (security issue) to anchor tags
  return html.replace(/<a([^>]*)>/g, '<a$1 target="_blank" rel="noopener noreferrer">');
};

// Configure marked for GitHub Flavored Markdown
marked.setOptions({
  gfm: true, // GitHub Flavored Markdown
  breaks: true, // Convert \n to <br>
  smartLists: true,
  smartypants: true,
  renderer: renderer,
});

// Configure DOMPurify to allow safe HTML elements and attributes
const purifyConfig = {
  ALLOWED_TAGS: [
    'p', 'br', 'strong', 'em', 'u', 'strike', 'del', 'code', 'pre',
    'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
    'ul', 'ol', 'li',
    'blockquote',
    'a',
    'table', 'thead', 'tbody', 'tr', 'th', 'td'
  ],
  ALLOWED_ATTR: ['href', 'target', 'rel', 'class'],
  ALLOW_DATA_ATTR: false
};

const MarkdownRenderer = ({ children, className = '' }) => {
  if (!children) return null;
  
  // Convert markdown to HTML
  const htmlContent = marked(children);
  
  // Sanitize the HTML to prevent XSS
  const sanitizedHtml = DOMPurify.sanitize(htmlContent, purifyConfig);
  
  return (
    <div 
      className={`markdown-content ${className}`}
      dangerouslySetInnerHTML={{ __html: sanitizedHtml }}
    />
  );
};

export default MarkdownRenderer;
